import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class UpdateModuleSubscriptionErrorAction implements Action {
  public static readonly type = 'UpdateModuleSubscriptionErrorAction';

  constructor(public error: BijbError) {
  }

  public type = UpdateModuleSubscriptionErrorAction.type;
}
